import React from 'react'
import { Box, MenuItem, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ChartType } from './ChartTypeToggle'

export enum TimeSpan {
  Day = 'Day',
  Month = 'Month',
  Year = 'Year',
}

type Props = {
  value: TimeSpan
  onChange: (value: TimeSpan) => void
  chartType: ChartType
}

export function ChartTimeSpanSelect({
  value,
  onChange,
  chartType,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Box width={120}>
      <TextField
        label={t('charts.timeSpan')}
        value={value}
        onChange={(event) => onChange(event.target.value as TimeSpan)}
        select
        variant="outlined"
        disabled={chartType === ChartType.Energy}
      >
        {Object.values(TimeSpan).map((option) => (
          <MenuItem key={option} value={option}>
            {t(`timeSpan.${option}`)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}
